import { redirect } from "@tanstack/react-router";
import type { RouterContext } from "../router";

export function requireActive(context: RouterContext) {
  if (context.isPending) return;
  if (!context.auth?.user) {
    throw redirect({ to: "/sign-in" });
  }
  if (context.auth.orgId == null) {
    throw redirect({ to: "/activate" });
  }
  if (!context.auth.onboarded) {
    throw redirect({ to: "/welcome" });
  }
}
